import { Flex, Text } from "@chakra-ui/react";
import { IconWarning } from "components/icons/Icons";
import { ManagerCellProps } from "../types";

export function ManagerCell({ managers, textColor }: ManagerCellProps) {
  return (
    <Flex align="center">
      {managers?.length > 0 ? (
        <Text
          color={textColor}
          fontSize="14px"
          lineHeight="24px"
          fontWeight="400"
          alignItems={"center"}
        >
          {managers}
        </Text>
      ) : (
        <Flex
          minW="135px"
          color={textColor}
          fontSize="14px"
          lineHeight="24px"
          fontWeight="400"
          minWidth="50px"
          height={"34px"}
          borderRadius="100px"
          padding="5px 20px"
          bgColor="#F3F5F5"
          alignItems="center"
        >
          <IconWarning width="20px" height="19px" marginRight="12px" />
          Needed
        </Flex>
      )}
    </Flex>
  );
}
